module.exports = __webpack_public_path__ + "img/edit_square.10f7a8a1.svg";